import type { AppFromApi } from '../lib/api';

// Re-export types for backwards compatibility
export type AppDefinition = AppFromApi;

// Categories type
export type Categories = Record<string, { name: string; color: string }>;

// Transform API app to display format
export function transformAppForDisplay(app: AppFromApi) {
  return {
    id: app.id,
    key: app.key,
    name: app.name,
    description: app.description,
    icon: app.icon,
    url: app.route.startsWith('http') ? app.route : `${import.meta.env.VITE_APP_BASE_URL || 'http://localhost:8080'}${app.route}`,
    color: app.color,
    gradient: app.metadata.gradient || [app.color, app.color],
    category: app.metadata.category || 'tools',
    badge: app.metadata.badge,
    isExternal: app.metadata.isExternal || false,
  };
}

// Display-ready app type
export interface DisplayApp {
  id: string;
  key: string;
  name: string;
  description: string;
  icon: string;
  url: string;
  color: string;
  gradient: [string, string];
  category: string;
  badge?: string;
  isExternal: boolean;
}
